import React, { useEffect } from "react";
import { ModalWrapper } from "./styles";
import "./contact.css";
import "./chef.css";

const CreateTodoModal = ({ closeModal }) => {
  let myRef;
  useEffect(() => {
    document.addEventListener("click", closeTodoModal);
    return () => {
      document.removeEventListener("click", closeTodoModal);
    };
  }, []);

  const closeTodoModal = (e) => {
    if (myRef && !myRef.contains(e.target)) {
      closeModal();
    }
  };

  return (
    <ModalWrapper>
      <form ref={(node) => (myRef = node)}>
        <h2
          style={{
            fontWeight: "900",
            textAlign: "center",
            color: "white",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          La livraison est à partir de 20 euros.
        </h2>
        <br />
        <h4 style={{ fontSize: "18px" }}>
          Envie d’un plat kebab, d’escalopes pannées ou encore de viande hachée
          ? Vous cherchez un fastfood rapide halal près de vous pour commander
          un repas à base de produits frais? Ne cherchez plus, Le Volcano met à
          votre disposition des plats savoureux avec la possibilité de livraison
          dans un rayon de 15 km autour du Mans notamment à Coulaines, Allonnes,
          Changé, Arnage,rouillon,la chapelle-saint-aubin… Pour plus de détails
          sur nos plats fast-food, contactez votre fastfood rapide au 09 50 85
          13 53 ou via le formulaire en ligne. <br />
        </h4>

        <button className="apropos-but" onClick={closeTodoModal}>
          Remonter en haut
        </button>
      </form>
    </ModalWrapper>
  );
};

export default CreateTodoModal;
